import React from 'react';
import { IconLoading } from '../../../components/buttons/IconButtons';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const StatusCard = ({ t, status }) => {
    return (
        <div className='d-flex align-items-center gap-3'>
            <div className=' background-linear-gradient-primary-800-500 d-flex justify-content-center align-items-center border-radius-8px w-68px h-68px'>
                <IconLoading  className='icon-color-general-00 ' width={32} height={32}/>
            </div>

            <div className='d-flex flex-column'>
                <p className='mb-0 font-color-primary-950 fs-16px ibl-font-w-400 text-uppercase'>{t('status')}</p>

                <p className='mb-0 fs-24px ibl-font-w-600 font-color-primary-950'>{t(status)}</p>
            </div>
        </div>
    );
};

export default StatusCard;
